import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=de48a012&scoped=true&"
import script from "./Shape.vue?vue&type=script&lang=js&"
export * from "./Shape.vue?vue&type=script&lang=js&"
import style0 from "./Shape.vue?vue&type=style&index=0&id=de48a012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de48a012",
  null
  
)

export default component.exports